if (!customElements.get('leo-collection-benefits')) {
  class LeoCollectionBenefits extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleToggle);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleToggle);
    }

    handleToggle(event) {
      const button = event.target.closest('[data-leo-benefit-toggle]');
      if (!button) return;

      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      const isOpen = button.getAttribute('aria-expanded') === 'true';
      this.querySelectorAll('[data-leo-benefit-toggle]').forEach((toggle) => {
        const controlledPanel = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', 'false');
        if (controlledPanel) controlledPanel.hidden = true;
      });

      button.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    }
  }

  customElements.define('leo-collection-benefits', LeoCollectionBenefits);
}
